import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {clearExistingLogins, getExistingLogins} from 'web-app/react/login/helpers';
import * as Sentry from 'web-app/services/sentry';

export const fetchAccountsForLogin = deviceId => {
    const existingLogins = getExistingLogins();

    if (deviceId === null && (existingLogins?.length ?? 0) > 0) {
        Sentry.captureMessage('[FBS-7135 - take two] deviceId is null', {
            extra: {
                existingLogin1: existingLogins?.at(0),
                existingLogin2: existingLogins?.at(1),
                openIdConnectInfo1: existingLogins?.at(0)?.useOpenIdConnect,
                openIdConnectInfo2: existingLogins?.at(1)?.useOpenIdConnect,
            },
        });
    }

    // We don't want stale data lying around and cause false positives in Sentry
    clearExistingLogins();

    return RESTClient.getAuthenticatedObservable(`v2/devices/${deviceId}/logins`).map(accounts => ({
        accounts: List(accounts),
    }));
};
